import { useState, useEffect } from "react";
import { useHttpChatAgent } from "./useHttpChatAgent";
import { IResponse } from "../../../hooks/useHttp";

interface Props {
  tenantid: string;
  agentUsername?: string;
  roleName?: string;
}

export interface IUsers {
  fullname: string;
  id: string;
  leader_id?: string;
  level: number;
  role_name: string;
  username: string;
}

const useFetchUserList = ({ tenantid, agentUsername, roleName }: Props) => {
  const [results, setResults] = useState<IUsers[]>([]);
  const route = (roleName == "QA" || roleName == "QC") ? "User" : "UserHierarchy";
  const url = `/${route}/${tenantid}/?username=${agentUsername}`;
  const { response, error, loading } = useHttpChatAgent({
    url,
    method: "get",
  });
  const retrieveData = (res: IResponse | undefined) => {
    const data = res?.data;
    setResults(data?.filter((i: any) => i.username != agentUsername) ?? []);
  };

  useEffect(() => {
    if (agentUsername) {
      retrieveData(response);
    }
  }, [response]);

  return { results, error, loading };
};

export default useFetchUserList;
